<template>
  <div class="app-header">
    <div class="container">
      <div class="app-header__row">
        <logo class="logo-app-header" />
        <div v-if="isRaceLive" class="race-status">📢 Live Now</div>
        <div class="main">
          <div class="title">
            Trainer Console
          </div>
          <ul>
            <li>
              <router-link to="/admin/live-run">Liverun</router-link>
            </li>
            <li>
              <router-link to="/admin/races">Schedule</router-link>
            </li>
            <li>
              <router-link to="/admin/past-run" >Past Runs</router-link>
            </li>
            <li>
              <router-link to="/admin/scheduled-runs">Scheduled Runs</router-link>
            </li>
            <li>
              <router-link to="/admin/runners/allrunners" >Runners</router-link>
            </li>
            <li>
              <router-link to="/admin/trainers" >Trainers</router-link>
            </li>
            <li>
              <router-link to="/admin/medal" >Medal</router-link>
            </li>
            <li>
              <router-link to="/admin/settings" >Settings</router-link>
            </li>

             <li>
              <router-link to="/admin/TP" >TP</router-link>
            </li>
             <li>
              <router-link to="/admin/AR&TD">AR&TD</router-link>
            </li>

            <li>
               <select class="more-select" v-model="selected" @change="handleSelect">
                <option value='' disabled selected>More</option>
                <option value="promo-codes" >Promo Codes</option>
                <option value="logs" >Logs</option>
                <option value="mongodb" >MongoDB</option>
                <option value="firebase-stats" >Firebase</option>
                <option v-if="isAdminUser" value="admin-data-operations" >Admin Data</option>
              </select>
            </li>
          </ul>
        </div>
        <user-info/>
      </div>
    </div>
  </div>
</template>

<script>
  import Logo from '@/components/AppHeader/Logo'
  import UserInfo from '@/components/AppHeader/UserInfo'
  import PastRun from '@/components/LiveRun/Race/PastRun'
  import {
    mapGetters,
    mapActions
  } from 'vuex'

  export default {
    name: 'AppHeader',
    data: () => ({
      selected:''
    }),
    components: {
      Logo,
      UserInfo,
      PastRun
    },
    computed: {
      ...mapGetters({
        isRaceLive: 'Race/isRaceLive',
        template: '#modal-template'
      }),
      isAdminUser() {
        return this.$isAdminUser()
      }
    },
    methods:{
      handleSelect(event){
        const target = event && event.target ? event.target.value : this.selected
        if (!target) {
          return
        }

        this.$router.push({ path: `/admin/${target}` })
        this.$nextTick(() => {
          this.selected = ''
        })
      },
      setSelection(path){
        this.selected=''
      },
    },
    created() {
      this.setSelection(this.$route)
    },    
    watch: {
      isRaceLive() {
        //console.log(this.isRaceLive)
      },
      $route(to, from) {
        this.setSelection(to)
      }
    }
  }
</script>

<style lang="stylus" scoped>
  .more-select option
    color black

  .more-select option:disabled
    color grey 

  select.more-select 
    appearance none
    -webkit-appearance none
    min-width 132px
    height 32px
    padding 0 34px 0 12px
    margin-top -6px
    border 1px solid rgba(255,255,255,0.34)
    border-radius 8px
    background-color rgba(255,255,255,0.08)
    background-image url("data:image/svg+xml,%3Csvg width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='white' stroke-width='1.9' stroke-linecap='round' stroke-linejoin='round' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='m6 9 6 6 6-6'/%3E%3C/svg%3E")
    background-repeat no-repeat
    background-position right 10px center
    background-size 14px 14px
    color white
    cursor pointer
    font-size 12px
    font-weight 600
    line-height 32px
    outline none
    text-transform none
    transition background-color .16s ease, border-color .16s ease, box-shadow .16s ease

    &:hover
      background-color rgba(255,255,255,0.14)
      border-color rgba(255,255,255,0.58)

    &:focus
      border-color rgba(255,255,255,0.78)
      box-shadow 0 0 0 3px rgba(255,255,255,0.14)

  .app-header
    background #423799
    padding 15px 0

    &__row
      display flex
      flex-flow row wrap
      justify-content space-between
      align-items center

    .logo-app-header
      //flex 1 0 100%
      //max-width calc(2.5/12 * 100% - (1 - 2.5/12) * 1px)

    .main
      text-align center

      .title
        font-size 22px
        color #fff

      ul
        list-style none
        display flex
        flex-flow row wrap
        justify-content center
        margin 10px 0 0

        li
          a
            border-bottom 2px solid transparent
            color #fff
            text-decoration none
            text-transform uppercase

            &.router-link-active
              border-bottom 2px solid #fff

          &:not(:last-child)
            margin 0 25px 0 0

    .user-info
      // flex 1 0 100%
      max-width calc(2.5/12 * 100% - (1 - 2.5/12) * 1px)

  .race-status
    position absolute
    margin-left 155px
    background-color #50ad69
    padding 5px 10px
    border-radius 3px
    color #fff
    margin-top -10px

  @media screen and (max-width: 900px){
      .user-info{
        margin: 10px auto;
        max-width: initial !important
      }  
      .logo-app-header{
        margin:auto
      }    
      .main ul li {
          margin-bottom: 10px!important;
      }
  }

</style>



// WEBPACK FOOTER //
// AppHeader.vue?5844bf64